import { Checkbox } from "antd";
import React from "react";

interface StandardPackage {
	title?: string;
	titlePrice?: string;
	items?: string[];
}

export const StandardPackage = ({
	title,
	titlePrice,
	items = [],
}: StandardPackage) => {
	return (
		<>
			<style>
				{`
            .ant-checkbox-checked .ant-checkbox-inner {
              background-color: #4f16c2 !important;
              border-color: #4f16c2 !important;
            }
          `}
			</style>

			<div className="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow ">
				<h2 className="text-xl font-semibold">{title}</h2>
				<p
					className="text-4xl font-bold mt-4"
					style={{ color: "#4f16c2" }}
				>
					{titlePrice}
				</p>

				<ul className="mt-6 space-y-2">
					{items.map((item, index) => (
						<li key={index} className="flex items-center gap-2">
							<Checkbox checked={true} />
							{item}
						</li>
					))}
				</ul>
			</div>
		</>
	);
};

export default StandardPackage;
